export const faqItems = [
  {
    q: "盲盒里的内容每次都一样吗？",
    a: "不一样。同一个主题盒会准备多于实际装入数量的单品，装箱时按比例随机分配，所以同批次的盒子之间也会有差别，偶尔还会出现比例更低的隐藏款。",
  },
  {
    q: "隐藏款是怎么决定放哪一盒的？",
    a: "隐藏款按较低比例混入整批，装箱阶段随机分配，不固定在盒子的某个位置。也就是说，开箱前无法从外观判断哪一盒里有什么。",
  },
  {
    q: "试吃清单里的分数怎么来的？",
    a: "分数来自试吃团对香气、口感、耐吃度和整体惊喜感的综合打分，取平均后保留一位小数。它只是参考，个人口味差异依然很大。",
  },
  {
    q: "开封后会过敏原提示吗？",
    a: "多数单品包装上会标注常见过敏原，如坚果、乳制品、小麦等。如果对某些成分敏感，建议开袋前先阅读包装上的配料与提示信息。",
  },
  {
    q: "零食要怎么存放比较好？",
    a: "薯片、锅巴这类酥脆零食开封后尽量一次吃完，或密封后放进阴凉干燥处；巧克力与软糖更适合放阴凉处，避免阳光直射和高温。",
  },
  {
    q: "本站会直接售卖或发货吗？",
    a: "不会。这里是一个分享盲盒开箱与零食试吃感受的内容页面，所做的是记录与整理，不提供下单、支付或配送等真实交易。",
  },
];